var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('div',{staticClass:"content",class:_vm.$style.textContainer},[_c('h2',{staticClass:"text-uppercase",class:_vm.$style.heading,domProps:{"innerHTML":_vm._s(_vm.$t('home.about.heading'))}}),_vm._v(" "),_c('p',{staticClass:"m-0",class:_vm.$style.text,domProps:{"innerHTML":_vm._s(_vm.$t('home.about.text'))}})])])
}]

export { render, staticRenderFns }